import { documentReady } from '#/utils/browser';
import { isClient } from '#/utils/general';

const SCRIPT_ID = 'rb2b-script';
const SCRIPT_BASE_URL = '/prx/rbx/';
const SCRIPT_KEY = 'DNXY8HXKY9O0';
const SCRIPT_URL = `${SCRIPT_BASE_URL}${SCRIPT_KEY}/${SCRIPT_KEY}.js.gz`;

declare global {
  interface Window {
    _reb2b: undefined;
    rb2b: undefined;
  }
}

/**
 * Remove the RB2B script.
 */
function remove() {
  if (!isClient()) {
    return;
  }

  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript) {
    existingScript.remove();
  }

  if (window._reb2b) {
    // biome-ignore lint/performance/noDelete: we need to remove the rb2b object from the window
    delete window._reb2b;
  }

  if (window.rb2b) {
    // biome-ignore lint/performance/noDelete: we need to remove the rb2b object from the window
    delete window.rb2b;
  }
}

/**
 * Load the RB2B script.
 */
function load() {
  if (!isClient()) {
    return;
  }

  remove();

  // Create and add the new script
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = SCRIPT_URL;
  script.async = true;
  document.body.appendChild(script);
}

/**
 * Refresh the RB2B script.
 */
function refresh() {
  if (!isClient()) {
    return;
  }
  load();
}

/**
 * Initialize the RB2B script when the document is ready.
 */
function initialize() {
  documentReady(() => {
    refresh();
  });
}

export default {
  remove,
  refresh,
  load,
  initialize,
};
